import React from 'react';

const NotFound: React.FC = () => (
  <div className="blog-index-no-posts-found">
    <h2>
      <b>No blog posts meet the selected filter criteria</b>
    </h2>
  </div>
);

export default NotFound;
